import { Moment } from 'moment';
import React, { FC } from 'react';
import { useHistory } from 'react-router';
import { UserId } from 'api/models';
import { humanise } from 'components/atoms/humanised-date';
import { getTimesheetUrl } from 'components/organisms/timesheets/common/utils';
import { useUser } from 'hooks/use-user';
import { InlineLink } from '../../basics';

interface Props {
  start: Moment;
  userId?: number;
  projectId?: number;
}
export const WeekViewLink: FC<Props> = ({ start, userId, projectId }) => {
  const {
    user: { userId: currentUserId },
  } = useUser();
  const { push } = useHistory();

  return (
    <InlineLink
      title={`${humanise(start)} - ${humanise(start.add(6, 'days'))}`}
      open={() => {
        push(
          getTimesheetUrl(
            UserId(currentUserId),
            userId ? UserId(userId) : undefined,
            start.format('YYYY-MM-DD'),
            projectId,
          ),
        );
      }}
    />
  );
};
